import { css } from "lit";
import { Style } from "../Styles";

export const styles = css`
    ${Style}

    :host {
        display: block;
        color: var(--sl-color-gray-700);
    }

    .footer {
        padding-top: 1rem;
        padding-bottom: 0.5rem;
        padding-right: 0rem;
        padding-left: 0rem;
        display: flex;
        align-items: center;
        column-gap: 0.5em;
    }

    .block-button {
        display: block;
        margin-top: 0.2rem;
    }

    .media {
        display: block;
        width: 10em;
        height: 10em;
        overflow: clip;
    }

    .media-import-error {
        color: red;
    }

    .reference {
        width: 100%;
        height: 100%;
    }

    .reference {
        width: 100%;
        align-items: center;
    }

    .reference sl-textarea {
        width: 100%;
    }

    .reference-header {
        display: flex;
        width: 100%;
    }

    .grid-3-column {
        grid-template-columns: minmax(auto, 30%) auto min-content;
    }

    .grid-3-column sl-select {
        width: 100%;
    }

    .grid-3-column .editor-label {
        margin-top: 0em;
        margin-bottom: 0em;
        display: block;
        text-align: center;
    }

    .help-wrapped-element {
        display: flex;
        flex-direction: row;
        width: 100%;
        overflow-x: hidden;
    }

    .checkbox-grid {
        display: inline-grid;
        grid-template-columns: repeat(2, auto);
        grid-gap: 5px 10px;
    }

    .permissions-user {
        width: 100%;
    }

    .permissions-user sl-input {
        width: 100%;
    }

    .permissions-user-entry {
        width: 100%;
    }

    sl-card {
        width: 100%;
    }

    .info-text {
        font-size: smaller;
        font-style: italic;
        font-weight: lighter;
        text-align: end;
        display: block;
        margin-top: 0.5em;
        margin-right: 1em;
    }

    .editor-media {
        height: 30em;
        width: 100%;
    }

    .editor-media-header {
        display: flex;
        justify-content: space-between;
        align-items: center;
    }

    .file-list-buttons {
        flex-wrap: wrap;
        justify-content: end;
    }

    textarea {
        min-height: 60em;
    }

    /* Markdown editor */
    .editor-toolbar {
        background-color: lightgray;
    }

    sl-text-area {
        width: 100%;
    }

    .editor-toolbar button {
        font-weight: 500;
        font-size: 1em;
    }

    @media only screen and (max-width: 640px) {
        .editor-media-container {
            flex-direction: column;
        }
    }
`;
